import * as React from 'react';
import { Helmet } from 'react-helmet';

import { Footer } from '@components/Footer';
import { Header } from '@components/Header';
import { SEO } from '@components/SEO';

import * as styles from './styles.module.scss';

interface SiteWrapperProps {
	data: any;
}

export const SiteWrapper: React.FunctionComponent<SiteWrapperProps> = ({ children, data }) => (
	<div className={styles.siteWrapper}>
		<SEO />
		<Helmet>
			<link rel="preconnect" href="https://fonts.gstatic.com" />
			<link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap" rel="stylesheet" />
			<script type="text/javascript" charSet="UTF-8" src="//cdn.cookie-script.com/s/0160fa19674f684d40573d59867c1602.js" />
		</Helmet>
		<Header {...data.navigation} />
		<div className={styles.siteContent}>
			{children}
		</div>
		<Footer {...data.footer} />
	</div>
);
